import React from 'react';
import TimelineController from '@/v2/components/controllers/TimelineController';
import TextBottom from '@/v2/components/atoms/TextBottom';
import splitTextToEvenLines from '@/v2/components/utils/TextUtils/SplitTextToEvenLines';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    background: PropTypes.string,
    time: PropTypes.object,
};

const defaultProps = {
    color: 'white',
    background: 'dark',
};

function Timer() {
    this.time = 0;
    this.Listener = () => {};
    this.Set = (time) => {
        this.time = time;
        this.Listener(time);
    };
}

class TimelineText extends React.Component {
    static Time() {
        return new Timer();
    }

    constructor(props) {
        super(props);
        const { data, time, text } = this.props;

        this.state = { textAnimate: null, lines: [text] };

        this.init(data, time);
    }

    componentWillUnmount() {
        this.timelineController = null;
    }

    init = (data, time) => {
        let currentText = '';
        // eslint-disable-next-line no-param-reassign
        time.Listener = this.update;

        this.timelineController = new TimelineController(data, {
            onShow: (items) => {
                const text = items.length ? items[0] : '';
                const { textAnimate } = this.state;

                if (text !== currentText) {
                    if (text) {
                        this.setState({ lines: splitTextToEvenLines(text), textAnimate: 'in' });
                        currentText = text;
                    } else if (textAnimate === 'in') {
                        this.setState({ lines: [], textAnimate: 'out' });
                    }
                }
            },
        });
    };

    update = (time) => {
        if (this.timelineController) {
            this.timelineController.Update(time * 1000);
        }
    };

    render() {
        const { textAnimate, lines } = this.state;
        const { color, background } = this.props;

        return (
            <>
                <TextBottom background={background} animate={textAnimate} color={color} component="h4">
                    {lines}
                </TextBottom>
            </>
        );
    }
}

TimelineText.propTypes = propTypes;
TimelineText.defaultProps = defaultProps;

export default TimelineText;
